const Spinner = () => {
  return (
    <div className='spinner-body'>
      <div className='spinner-container'>
        <div className='spinner'></div>
      </div>
    </div>
  );
};

export default Spinner;
